import * as React from 'react';
import styled from 'styled-components';
import { Form, useFormsContext } from '@ally/forms';
import { CardSelectionCard, CardSelectionGroup, Space, } from '@ally/metronome-ui';
const StyledCardSelectionGroup = styled(CardSelectionGroup) `
  ${({ theme: { media, space } }) => `
    ${media.up('md')} {
      max-width: 550px;
    }
    margin-bottom: ${space.lg}
  `}
`;
export const PushTextOrVoiceSelection = ({ hasPushApproveAuthenticator, maskText, hasSingleDisplayOption, setSelectedRadioValue, onMethodSelectionChange, }) => {
    const { setFieldValue } = useFormsContext();
    return (React.createElement(Space, { mb: "md" },
        React.createElement(Form, { id: "verify-login" },
            React.createElement(StyledCardSelectionGroup, { variant: "single-select", align: "stacked", id: "selectLoginType", ariaLabelledby: "select-account-type-label", defaultSelection: hasPushApproveAuthenticator ? 'push approval' : 'text message', onSelection: (cardId) => {
                    setFieldValue('loginType', cardId);
                    if (cardId) {
                        setSelectedRadioValue(cardId);
                    }
                    onMethodSelectionChange(cardId);
                } },
                hasPushApproveAuthenticator ? (React.createElement(CardSelectionCard, { cardId: "push approval", title: "Push approval", allytmfn: "pushApproval", description: "We'll send you a push notification. You'll respond in the app now and any time we need to confirm it's you." })) : (React.createElement(React.Fragment, null)),
                React.createElement(CardSelectionCard, { cardId: "text message", title: "Text", allytmfn: "textMessage", description: hasSingleDisplayOption
                        ? `We'll text a security code to ${maskText}.`
                        : "We'll text you a security code." }),
                React.createElement(CardSelectionCard, { cardId: "voice", title: "Phone call", allytmfn: "phoneCall", description: hasSingleDisplayOption
                        ? `We'll call ${maskText} with a security code.`
                        : "We'll call you with a security code." })))));
};
//# sourceMappingURL=PushTextOrVoiceSelection.js.map